module.exports = __webpack_public_path__ + "img/kaavio.77370d7f.png";